import {
	apiAppBusinessSmssettingsListrefills,
	type SmsRefill
} from '#lib/types/generated/index.js';
import { writable } from 'svelte/store';

export const smsRefillStore = writable<SmsRefill[]>([]);

export function loadSmsRefills(): Promise<SmsRefill[]> {
	return apiAppBusinessSmssettingsListrefills().then((res) => {
		smsRefillStore.set(res.items);
		return res.items;
	});
}
